// =============================================================
// SPONSOR BANNER — üçüncü taraf reklam slotu
// Görsel tıklanabilir; ekstrapersonel.net yeni sekmede açılır
// =============================================================

import styles from "./SponsorBanner.module.css";

export function SponsorBanner() {
  return (
    <aside className={styles.banner} aria-label="Sponsorlu içerik">
      <div className={styles.banner__inner}>
        <p className={styles.banner__eyebrow}>
          <span aria-hidden="true">●</span>
          Sponsorlu İçerik · İş Ortağı
        </p>
        <a
          href="https://ekstrapersonel.net"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.banner__link}
          aria-label="ekstrapersonel.net — personel ve iş ilanları platformu (yeni sekmede açılır)"
        >
          <img
            className={styles.banner__image}
            src="/img/ekstrapersonelBanner.jpeg"
            alt="ekstrapersonel.net — hızlı kayıt, binlerce iş ilanı, güvenilir iş ortağı"
            width={1983}
            height={793}
            loading="lazy"
            decoding="async"
          />
        </a>
      </div>
    </aside>
  );
}
